<template>
  <div>
    <div class="height-80 padding-top-1x">
      <div
      class="
        flex-row flex-center
        bg-g13
        justify-between
        margin-top-1x margin-left-3x
        height-60
        padding-left-3x
        border-10x
        margin-right-3x
      "
    >
      <div class="flex-row flex-center">
        <img
          class="icon-13x"
          :src="uploadpath + 'resource/' + Res.search"
          alt=""
        />
        <input
          class="border-none bg-g13 f-24 height-60"
          placeholder="输入您想要的内容"
          v-model="content"
        />
      </div>
      <button
        class="border-10x f-w f-24 border-none bg-g9 width-15x height-60"
        @click="sousuo"
      >
        搜索
      </button>
    </div>
    </div>
    <div class="bg-g h-100">
      <div
        class="margin-left-3x width-330 height-450 bg-w margin-top"
        v-for="(item, i) in shoplist"
        v-bind:key="i"
        style="display: inline-block"
      >
        <div @click="detail(item.id)">
          <img
            class="icon-15x"
            :src="uploadpath + 'shop/' + item.image"
            alt=""
          />
        </div>
        <div class="h2 margin-top-3x margin-left margin-right">
          {{ item.name }}
        </div>
      </div>
    </div>
    <img
      class="icon-11x under2"
      :src="uploadpath + 'resource/' + Res.back"
      alt=""
      @click="routeto('/')"
    />
  </div>
</template>
<script>
import Config from "../Config";
import { PageHelper } from "../PageHelper";
import { HttpHelper } from "../HttpHelper";
import { Utils } from "../Utils";

export default {
  data() {
    return {
      Res: {},
      Inst: {},
      Member: null,
      bannerlist: [],
      productlist: [],
      problemlist: [],
      attrlist: [],
      list: [],
      show: false,
      right: "A",
      content: "",
      shoplist: [],
    };
  },
  created() {
    PageHelper.Init(this);
  },
  methods: {
    sousuo() {
      HttpHelper.Post("shop/search", {
        content: this.content,
      }).then((ret) => {
        this.shoplist = ret;
      });
    },
    detail(id) {
      this.routeto("detail/" + id + "/" + 0);
    },
  },
};
</script>
<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/Search.vue